import { render, staticRenderFns } from "./CompraDireta.vue?vue&type=template&id=56ee5bd3&scoped=true"
import script from "./CompraDireta.vue?vue&type=script&lang=js"
export * from "./CompraDireta.vue?vue&type=script&lang=js"
import style0 from "./CompraDireta.vue?vue&type=style&index=0&id=56ee5bd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ee5bd3",
  null
  
)

export default component.exports